/** Eenmalige intro bij eerste zichtbaarheid van het volgende-actie-paneel op Vandaag. */
import { useCallback, useEffect, useRef, useState } from 'react';
import { ONBOARDING_HINT_NEXT_ACTION_PANEL } from '@/constants/onboardingHints';
import { useTier } from '@/features/tier/useTier';
import {
  isDesktopBreakpoint,
  useBreakpoint,
} from '@/hooks/ui/useBreakpoint';
import { markHintSeen } from '@/services/userService';

/**
 * @param {Object} params
 * @param {boolean} params.panelVisible
 * @param {string | undefined} params.userId
 */
export function useNextActionPanelHint({ panelVisible, userId }) {
  const breakpoint = useBreakpoint();
  const isDesktop = isDesktopBreakpoint(breakpoint);
  const { seenHints, profileLoaded } = useTier();
  const initRef = useRef(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (initRef.current) {
      return;
    }
    if (!panelVisible || !userId || !profileLoaded || !isDesktop) {
      return;
    }
    initRef.current = true;
    if (seenHints.includes(ONBOARDING_HINT_NEXT_ACTION_PANEL)) {
      return;
    }
    setOpen(true);
    void markHintSeen(userId, ONBOARDING_HINT_NEXT_ACTION_PANEL);
  }, [panelVisible, userId, profileLoaded, seenHints, isDesktop]);

  const dismiss = useCallback(() => {
    setOpen(false);
  }, []);

  return { showHint: open, dismissHint: dismiss };
}
